import { ReactElement } from 'react'
import styled from 'styled-components'
import { defaultTheme } from '../../../theme'
import { FILTER_OPTIONS_LIST_MAX_HEIGHT } from '../constants'
import { ListItem } from '../interfaces'
import { partitionSelectedFilterOptions } from '../partitionFilterOptions'
import { CheckboxListWrapper } from './CheckboxListWrapper'

interface FilterOptionListProps {
  groupName: string
  options: ListItem[]
  onChange: (filterName: string, selectedOptions: ListItem[]) => void
}

export const FilterOptionList = ({
  groupName,
  options,
  onChange,
}: FilterOptionListProps): ReactElement => {
  const { selected, unselected } = partitionSelectedFilterOptions(options)

  const mergeSectionChange = (
    sectionOptions: ListItem[],
    activeOptions: ListItem[]
  ): void => {
    const sectionValues = new Set(sectionOptions.map((item) => item.value))
    const activeValues = new Set(activeOptions.map((item) => item.value))
    const mergedOptions = options.map((option) => {
      if (!sectionValues.has(option.value)) {
        return option
      }
      return { ...option, active: activeValues.has(option.value) }
    })
    onChange(
      groupName,
      mergedOptions.filter((item) => item.active)
    )
  }

  const showDivider = selected.length > 0 && unselected.length > 0

  return (
    <>
      {selected.length > 0 && (
        <SelectedSection>
          <CheckboxListWrapper
            groupName={groupName}
            options={selected}
            onChange={(_, activeOptions) =>
              mergeSectionChange(selected, activeOptions)
            }
          />
        </SelectedSection>
      )}
      {showDivider && <OptionsDivider />}
      {unselected.length > 0 && (
        <UnselectedSection>
          <CheckboxListWrapper
            groupName={groupName}
            options={unselected}
            onChange={(_, activeOptions) =>
              mergeSectionChange(unselected, activeOptions)
            }
          />
        </UnselectedSection>
      )}
    </>
  )
}

const SelectedSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const UnselectedSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: ${FILTER_OPTIONS_LIST_MAX_HEIGHT}px;
  overflow-y: auto;
`

const OptionsDivider = styled.div`
  border-top: 1px solid ${defaultTheme.colors.border};
  margin: 4px 0 8px;
  width: 100%;
`
